import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M27 6H5a1 1 0 0 0-1 1v19a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-6h6v2a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2V7a1 1 0 0 0-1-1M11 26H6V16h5zm0-12H6V8h5zm8 4h-6V8h6zm7 4h-5v-6h5zm0-8h-5V8h5z"
    />
  </svg>
);
const SvgIconKanban = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconKanban);
export default Memo;
